/**
 * CrossArcheBadge — "Also in Fias 360" indicator. Render in the row
 * cell next to the contact / company name when the cross-arche
 * presence batch read returns true for that id. The presence batch
 * fetch is owned by the parent list page (uses
 * useFiasLeadsCrossArchePresence directly).
 */

export function CrossArcheBadge({ present }: { present: boolean }) {
  if (!present) return null;
  return (
    <span
      className="ml-2 rounded bg-emerald-100 text-emerald-700 px-1.5 py-0.5 text-[10px] font-medium uppercase"
      title="This record is also tracked in Fias 360 (Customer Success)"
    >
      Also in 360
    </span>
  );
}
